import { Show } from 'solid-js';
import { Dynamic } from 'solid-js/web';

type TextProps = {
    heading: string;
    description: string | null;
    price: string;
    tag?: string;
};

export default function Text(props: {textProps: TextProps}) {
    //console.log(props.textProps.tag, 'headingtag inside text.tsx');
      
    const getCorrectTag = () => {
        switch (props.textProps.tag) {
            case 'h1':
                return 'h1';
            case 'h2':
                return 'h2';
            case 'h3':
                return 'h3';
            case 'h4':
                return 'h4';
            case 'h5':
                return 'h5';
            case 'h6':
                return 'h6';
            default:
                return 'h2';
        }
    };
    return (
        <>
            <Dynamic
                component={getCorrectTag()}
                class='text-headerL font-paytone'
                style={{
                    background:
                    'var(--gradient-primary-warm, linear-gradient(180deg, #FF8B47 0%, #F15A22 100%))',
                    'background-clip': 'text',
                    '-webkit-background-clip': 'text',
                    '-webkit-text-fill-color': 'transparent',
                }}
            >
                {props.textProps.heading}
            </Dynamic>
            <p class='text-paragraphL font-bold'>{props.textProps.price}</p>
            <Show when={props.textProps.description}>
                <p class='text-left text-paragraphS pb-xs'>{props.textProps.description}</p>
            </Show>
        </>
    );
}
